import { LoadingSpinner } from "@clipboard-health/ui-components";
import { getTheme } from "@clipboard-health/ui-theme";
import { isDefined } from "@clipboard-health/util-ts";
import { Box, ThemeProvider } from "@mui/material";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { PageHeaderTopRow } from "@src/appV2/redesign/components/PageHeaderTopRow";
import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";
import { useParams } from "react-router-dom";

import {
  transformPlacementCandidateBanData,
  useGetPlacementCandidateBan,
} from "../../api/useGetPlacementCandidateBan";
import { BanDisputeStep, useDisputeBanSteps } from "../../hooks/useDisputeBanSteps";
import { BanDisputeForm } from "./DisputeBanForm";

interface BanDisputePageParams {
  banId?: string;
}

export function BanDisputePage() {
  const { banId } = useParams<BanDisputePageParams>();

  const { data: banResponse, isLoading: isLoadingBan } = useGetPlacementCandidateBan(
    { banId: banId ?? "" },
    { enabled: isDefined(banId) }
  );
  const ban = banResponse ? transformPlacementCandidateBanData(banResponse) : undefined;

  const { currentStep, setCurrentStep, handleBack } = useDisputeBanSteps({
    ban,
    isLoadingBan,
  });

  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper variant="tertiary">
        {(isLoadingBan || currentStep === undefined) && (
          <Box
            sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}
          >
            <LoadingSpinner size="medium" />
          </Box>
        )}
        {!isLoadingBan && ban && currentStep !== undefined && (
          <>
            <PageHeaderTopRow
              title={`Step ${currentStep} of 3`}
              hideBackButton={currentStep === BanDisputeStep.CONFIRMATION}
              rightAction={
                currentStep === BanDisputeStep.CONFIRMATION ? (
                  <IconButton iconType="close" variant="outlined" onClick={handleBack} />
                ) : undefined
              }
              onClickBack={handleBack}
            />
            <Box sx={{ paddingX: 5, paddingTop: 4 }}>
              <BanDisputeForm
                banId={ban.id}
                workerId={ban.workerId}
                currentStep={currentStep}
                setCurrentStep={setCurrentStep}
              />
            </Box>
          </>
        )}
      </PageWrapper>
    </ThemeProvider>
  );
}
